import type {AdLocation} from '@frontend/modules/public/ads/AdsModuleTypes'

// Поиск локации по slugWithId (рекурсивный).
export function findLocationBySlugWithId(
    locations: AdLocation[],
    slugWithId: string | null
): null | AdLocation {
    if (slugWithId === null) {
        return null
    }
    for (const item of locations) {
        if (item.slugWithId === slugWithId) {
            return item
        } else if (item.children.length) {
            const location: AdLocation | null = findLocationBySlugWithId(
                item.children,
                slugWithId
            )
            if (location) {
                return location
            }
        }
    }
    return null
}
